"use client";

import { useEffect, useState } from "react";

export default function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handler = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const current = window.scrollY;
      setProgress(total > 0 ? Math.min(1, Math.max(0, current / total)) : 0);
    };

    window.addEventListener("scroll", handler, { passive: true });
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const inActionZone = progress >= 0.95;
  const colorClass = inActionZone ? "bg-brand-primary" : "bg-brand-secondary-mid";

  return (
    <div
      className={`fixed top-0 left-0 z-[51] h-0.5 ${colorClass} transition-[width,background-color] duration-300 ease-out`}
      style={{ width: `${progress * 100}%` }}
      aria-hidden
    />
  );
}
